import { RefreshCw } from "lucide-react";

export const PageHeader = ({ eyebrow, title, description, onRefresh, loading, children }) => (
  <header className="page-header">
    <div>
      <span className="overline" data-testid="page-eyebrow">{eyebrow}</span>
      <h1 data-testid="page-title">{title}</h1>
      <p data-testid="page-description">{description}</p>
    </div>
    <div className="header-actions">
      {children}
      {onRefresh && <button className="button secondary" onClick={onRefresh} disabled={loading} data-testid="refresh-page-button"><RefreshCw size={16} className={loading ? "spin" : ""} />Refresh</button>}
    </div>
  </header>
);